import { Fill } from 'modules/common/components/_ui/ProgressBar'
import { useMemo } from 'react'
import { SIGNUP_STEPS } from '../config/signup'
import { useSignupStoreStep } from '../store/useSignupStore'
import { PROGRESS_BAR_MAX } from './../../common/components/_ui/ProgressBar'

export const useSignupProgressBar = (): { fill: Fill } => {
  const signupStep = useSignupStoreStep()
  const stepIndex = useMemo(() => {
    return SIGNUP_STEPS.findIndex((step) => step.stepName === signupStep)
  }, [signupStep])

  return {
    fill: Math.ceil(
      ((stepIndex + 1) * PROGRESS_BAR_MAX) / SIGNUP_STEPS.length
    ) as Fill,
  }
}
